import {Injectable} from '@angular/core';
import {Resolve,ActivatedRouteSnapshot,RouterStateSnapshot} from "@angular/router";
import {EventWithVenue} from "../models";
import {EventApi} from "../services/webservice";
import {Observable} from "rxjs";
@Injectable()
export class EventsOnSaleResolver implements Resolve<EventWithVenue[]> {

    constructor(
        private eventApi: EventApi
    ) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<EventWithVenue[]> {
		return this.eventApi.overview("ON_SALE");
    }

}


// WEBPACK FOOTER //
// ./src/app/resolver/events-on-sale.resolver.ts